module.exports = __webpack_public_path__ + "img/redTitle.1fb1253b.png";